import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './HeaderCarousel.css';
import React from 'react';
import { get, getDictionaryItem } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import HeaderMedia from '../57_HeaderMedia/HeaderMedia';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import NoDataSource from '../atoms/NoDataSource';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import DarkThemeControl from '../BrightcoveVideosAtoms/DarkThemeControl';
var HeaderCarousel = function HeaderCarousel(_ref) {
  var fields = _ref.fields,
    params = _ref.params,
    rendering = _ref.rendering;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var hasItems = Boolean(get(fields, 'data.item.children.length'));
  var dictionary = get(fields, 'data.dictionary');
  var darkModeTitle = getDictionaryItem(dictionary, "dark mode") || '';
  var carousalRef = React.useRef();
  var darkMode = get(sitecoreContext, 'darkMode');
  var actions = get(sitecoreContext, 'actions', {});
  var _actions$changeThemeF = actions.changeThemeFunction,
    changeThemeFunction = _actions$changeThemeF === void 0 ? function () {} : _actions$changeThemeF;
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    carouselEvent = _React$useState2[0],
    setCarouselEvent = _React$useState2[1];
  React.useEffect(function () {
    if (carousalRef.current) {
      carousalRef.current.classList.remove('height-fix');
    }
  }, []);
  if (rendering && !rendering.dataSource) {
    console.info('HeaderCarousel component render skipped. No dataSource provided');
    return pageEditing ? /*#__PURE__*/React.createElement(NoDataSource, {
      title: rendering.componentName
    }) : null;
  }
  if (!fields || !hasItems) {
    console.info('HeaderCarousel component render skipped. No fields provided');
    return pageEditing ? /*#__PURE__*/React.createElement("div", {
      className: "no-data"
    }, " [HeaderCarousel component is empty: please provide data source]") : null;
  }
  var _fields$data = fields.data,
    nextPrevAnalytics = _fields$data.nextPrevAnalytics,
    navBubblesAnalytics = _fields$data.navBubblesAnalytics,
    mobileSlidesAnalytics = _fields$data.mobileSlidesAnalytics,
    videoAnalytics = _fields$data.videoAnalytics;
  var analyticsParams = {
    eventName: params.eventName,
    eventCat: params.eventCat,
    eventAct: params.eventAct
  };
  var items = get(fields, 'data.item.children');
  var isSecondaryCarousel = Boolean(params && params.mediaSize === 'Secondary');
  var renderItems = function renderItems() {
    return items.map(function (item) {
      return /*#__PURE__*/React.createElement(HeaderMedia, {
        key: item.image.jss.value.src,
        fields: {
          data: {
            item: item,
            videoAnalytics: videoAnalytics
          }
        },
        params: _objectSpread({}, params),
        carouselEvent: carouselEvent
      });
    });
  };
  var mergeSlideAction = function mergeSlideAction() {
    setCarouselEvent("slide ".concat(Math.floor(Math.random() * 101)));
    tealiumClickFunc(tealiumMergeClickData(mobileSlidesAnalytics, params));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyle, " ").concat(rtl ? rtlStyles : ltrStyles, " header-carousel")
  }, /*#__PURE__*/React.createElement("div", {
    className: "global-carousel-container height-fix",
    ref: carousalRef
  }, params && params['Dark Mode Switcher Show'] ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "dark-mode-switcher-box"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-1 col-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-7 col-7"
  }, /*#__PURE__*/React.createElement(DarkThemeControl, {
    handleClick: changeThemeFunction,
    label: darkModeTitle,
    value: darkMode,
    params: params
  })))) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(CarouselProvider, null, function (_ref2) {
    var renderCarousel = _ref2.renderCarousel,
      renderPreviousButton = _ref2.renderPreviousButton,
      renderNextButton = _ref2.renderNextButton,
      renderDots = _ref2.renderDots,
      state = _ref2.state;
    return /*#__PURE__*/React.createElement(React.Fragment, null, renderCarousel(renderItems(), {
      responsive: isSecondaryCarousel ? {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 1024
          },
          items: 1
        },
        mobile: {
          breakpoint: {
            max: 1023,
            min: 0
          },
          items: 1
        }
      } : {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 0
          },
          items: 1
        },
        mobile: {
          breakpoint: {
            max: 1023,
            min: 0
          },
          items: 1
        }
      }
    }, function () {
      return mergeSlideAction();
    }), /*#__PURE__*/React.createElement("div", {
      className: "header-bb__controls-sec ".concat(rtl ? 'btn-group-rtl' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-icon-white header-bb__controls d-none d-md-block"
    }, renderPreviousButton(function () {
      setCarouselEvent("prev ".concat(Math.floor(Math.random() * 101)));
      tealiumClickFunc.bind(null, tealiumMergeClickData(nextPrevAnalytics, analyticsParams));
    })), /*#__PURE__*/React.createElement("div", {
      className: "my-icon-white header-bb__controls d-none d-md-block"
    }, renderNextButton(function () {
      setCarouselEvent("next ".concat(Math.floor(Math.random() * 101)));
      tealiumClickFunc.bind(null, tealiumMergeClickData(nextPrevAnalytics, analyticsParams));
    }))), /*#__PURE__*/React.createElement("div", {
      className: "header__pagination-dots"
    }, renderDots(function () {
      setCarouselEvent("dots ".concat(Math.floor(Math.random() * 101)));
      tealiumClickFunc.bind(null, tealiumMergeClickData(navBubblesAnalytics, analyticsParams));
    })));
  })));
};
export var commonStyle = "c1wenh3u";
var ltrStyles = "l1x2l1pc";
var rtlStyles = "r1w9d3zn";
export default HeaderCarousel;